import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export const acknowledgeEnrollmentRemoval = async (input: {
  centerId: number
  enrollmentId: number
}) => {
  const { centerId, enrollmentId } = input
  return restApiClient
    .url(
      constructApiUrl(API.centers.acknowledgeEnrollmentRemoval.url, { id: centerId, enrollmentId })
    )
    .post()
}
